export const province = [
    {
        text: '北京',
        value: 12593,
        children: [
            {
                text: '东城',
                value: 49,
                key: '\u0004',
            },
            {
                text: '西城',
                value: 50,
                key: '\u0005',
            },
            {
                text: '朝阳',
                value: 53,
                key: '\u0006',
            },
            {
                text: '丰台',
                value: 54,
                key: '\u0007',
            },
            {
                text: '石景山',
                value: 55,
                key: '\b',
            },
            {
                text: '海淀',
                value: 56,
                key: '\t',
            },
            {
                text: '门头沟',
                value: 57,
                key: '\n',
            },
            {
                text: '房山',
                value: 12593,
                key: '\u000b',
            },
            {
                text: '通州',
                value: 12594,
                key: '\f',
            },
            {
                text: '顺义',
                value: 12595,
                key: '\\r',
            },
            {
                text: '昌平',
                value: 12849,
                key: '\u000e',
            },
            {
                text: '大兴',
                value: 12852,
                key: '\u000f',
            },
            {
                text: '平谷',
                value: 12854,
                key: '\u0010',
            },
            {
                text: '怀柔',
                value: 12855,
                key: '\u0011',
            },
            {
                text: '密云',
                value: 12856,
                key: '\u0012',
            },
            {
                text: '延庆',
                value: 12857,
                key: '\u0013',
            },
        ],
    },
    {
        text: '天津',
        value: 12594,
        key: '\u0014',
        children: [
            {
                text: '和平',
                value: 49,
                key: '\u0015',
            },
            {
                text: '河东',
                value: 50,
                key: '\u0016',
            },
            {
                text: '河西',
                value: 51,
                key: '\u0017',
            },
            {
                text: '南开',
                value: 52,
                key: '\u0018',
            },
            {
                text: '河北',
                value: 53,
                key: '\u0019',
            },
            {
                text: '红桥',
                value: 54,
                key: '\u001a',
            },
            {
                text: '滨海新区',
                value: 12854,
                key: '\u001b',
            },
            {
                text: '东丽',
                value: 12592,
                key: '\u001c',
            },
            {
                text: '西青',
                value: 12593,
                key: '\u001d',
            },
            {
                text: '津南',
                value: 12594,
                key: '\u001e',
            },
            {
                text: '北辰',
                value: 12595,
                key: '\u001f',
            },
            {
                text: '宁河',
                value: 12849,
                key: ' ',
            },
            {
                text: '武清',
                value: 12850,
                key: '!',
            },
            {
                text: '静海',
                value: 12851,
                key: '"',
            },
            {
                text: '宝坻',
                value: 12852,
                key: '#',
            },
            {
                text: '蓟县',
                value: 12853,
                key: '$',
            },
        ],
    },
    {
        text: '河北',
        value: 12595,
        key: '%',
        children: [

            {
                text: '石家庄',
                value: 49,
                key: '&',
            },
            {
                text: '唐山',
                value: 50,
                key: '>',
            },
            {
                text: '秦皇岛',
                value: 51,
                key: 'M',
            },
            {
                text: '邯郸',
                value: 52,
                key: 'U',
            },
            {
                text: '邢台',
                value: 53,
                key: 'i',
            },
            {
                text: '保定',
                value: 54,
                key: '}',
            },
            {
                text: '张家口',
                value: 55,
                key: '',
            },
            {
                text: '承德',
                value: 56,
                key: '©',
            },
            {
                text: '沧州',
                value: 57,
                key: 'µ',
            },
            {
                text: '廊坊',
                value: 12592,
                key: 'Æ',
            },
            {
                text: '衡水',
                value: 12593,
                key: 'Ñ',
            },
        ],
    },
    {
        text: '山西',
        value: 12596,
        key: 'Ý',
        children: [

            {
                text: '太原',
                value: 49,
                key: 'Þ',
            },
            {
                text: '大同',
                value: 50,
                key: 'é',
            },
            {
                text: '阳泉',
                value: 51,
                key: 'õ',
            },
            {
                text: '长治',
                value: 52,
                key: 'û',
            },
            {
                text: '晋城',
                value: 53,
                key: 'ĉ',
            },
            {
                text: '朔州',
                value: 54,
                key: 'Đ',
            },
            {
                text: '晋中',
                value: 55,
                key: 'ė',
            },
            {
                text: '运城',
                value: 56,
                key: 'ģ',
            },
            {
                text: '忻州',
                value: 57,
                key: 'ı',
            },
            {
                text: '临汾',
                value: 12592,
                key: 'ŀ',
            },
            {
                text: '吕梁',
                value: 12593,
                key: 'Œ',
            },
        ],
    },
    {
        text: '内蒙古',
        value: 12597,
        key: 'Š',
        children: [

            {
                text: '呼和浩特',
                value: 49,
                key: 'š',
            },
            {
                text: '包头',
                value: 50,
                key: 'ū',
            },
            {
                text: '乌海',
                value: 51,
                key: 'ŵ',
            },
            {
                text: '赤峰',
                value: 52,
                key: 'Ź',
            },
            {
                text: '通辽',
                value: 53,
                key: 'Ɔ',
            },
            {
                text: '鄂尔多斯',
                value: 54,
                key: 'Ə',
            },
            {
                text: '呼伦贝尔',
                value: 55,
                key: 'Ƙ',
            },
            {
                text: '巴彦淖尔',
                value: 56,
                key: 'Ʀ',
            },
            {
                text: '乌兰察布',
                value: 57,
                key: 'Ʈ',
            },
            {
                text: '兴安',
                value: 12850,
                key: 'ƺ',
            },
            {
                text: '锡林郭勒',
                value: 12853,
                key: 'ǁ',
            },
            {
                text: '阿拉善',
                value: 12857,
                key: 'ǎ',
            },
        ],
    },
    {
        text: '辽宁',
        value: 12849,
        key: 'ǒ',
        children: [

            {
                text: '沈阳',
                value: 49,
                key: 'Ǔ',
            },
            {
                text: '大连',
                value: 50,
                key: 'ǡ',
            },
            {
                text: '鞍山',
                value: 51,
                key: 'Ǭ',
            },
            {
                text: '抚顺',
                value: 52,
                key: 'Ǵ',
            },
            {
                text: '本溪',
                value: 53,
                key: 'Ǽ',
            },
            {
                text: '丹东',
                value: 54,
                key: 'ȃ',
            },
            {
                text: '锦州',
                value: 55,
                key: 'Ȋ',
            },
            {
                text: '营口',
                value: 56,
                key: 'Ȓ',
            },
            {
                text: '阜新',
                value: 57,
                key: 'ș',
            },
            {
                text: '辽阳',
                value: 12592,
                key: 'ȡ',
            },
            {
                text: '盘锦',
                value: 12593,
                key: 'ȩ',
            },
            {
                text: '铁岭',
                value: 12594,
                key: 'Ȯ',
            },
            {
                text: '朝阳',
                value: 12595,
                key: 'ȶ',
            },
            {
                text: '葫芦岛',
                value: 12596,
                key: 'Ⱦ',
            },
        ],
    },
    {
        text: '吉林',
        value: 12850,
        key: 'Ʌ',
        children: [

            {
                text: '长春',
                value: 49,
                key: 'Ɇ',
            },
            {
                text: '吉林',
                value: 50,
                key: 'ɑ',
            },
            {
                text: '四平',
                value: 51,
                key: 'ɛ',
            },
            {
                text: '辽源',
                value: 52,
                key: 'ɢ',
            },
            {
                text: '通化',
                value: 53,
                key: 'ɧ',
            },
            {
                text: '白山',
                value: 54,
                key: 'ɯ',
            },
            {
                text: '松原',
                value: 55,
                key: 'ɶ',
            },
            {
                text: '白城',
                value: 56,
                key: 'ɼ',
            },
            {
                text: '延边',
                value: 12852,
                key: 'ʂ',
            },
        ],
    },
    {
        text: '黑龙江',
        value: 12851,
        key: 'ʋ',
        children: [

            {
                text: '哈尔滨',
                value: 49,
                key: 'ʌ',
            },
            {
                text: '齐齐哈尔',
                value: 50,
                key: 'ʟ',
            },
            {
                text: '鸡西',
                value: 51,
                key: 'ʰ',
            },
            {
                text: '鹤岗',
                value: 52,
                key: 'ʺ',
            },
            {
                text: '双鸭山',
                value: 53,
                key: '˃',
            },
            {
                text: '大庆',
                value: 54,
                key: 'ˌ',
            },
            {
                text: '伊春',
                value: 55,
                key: '˖',
            },
            {
                text: '佳木斯',
                value: 56,
                key: '˨',
            },
            {
                text: '七台河',
                value: 57,
                key: '˳',
            },
            {
                text: '牡丹江',
                value: 12592,
                key: '˸',
            },
            {
                text: '黑河',
                value: 12593,
                key: '̃',
            },
            {
                text: '绥化',
                value: 12594,
                key: '̊',
            },
            {
                text: '大兴安岭',
                value: 12855,
                key: '̕',
            },
        ],
    },
    {
        text: '上海',
        value: 13105,
        key: '̙',
        children: [

            {
                text: '黄浦',
                value: 49,
                key: '̚',
            },
            {
                text: '卢湾',
                value: 51,
                key: '̛',
            },
            {
                text: '徐汇',
                value: 52,
                key: '̜',
            },
            {
                text: '长宁',
                value: 53,
                key: '̝',
            },
            {
                text: '静安',
                value: 54,
                key: '̞',
            },
            {
                text: '普陀',
                value: 55,
                key: '̟',
            },
            {
                text: '闸北',
                value: 56,
                key: '̠',
            },
            {
                text: '虹口',
                value: 57,
                key: '̡',
            },
            {
                text: '杨浦',
                value: 12593,
                key: '̢',
            },
            {
                text: '闵行',
                value: 12594,
                key: '̣',
            },
            {
                text: '宝山',
                value: 12595,
                key: '̤',
            },
            {
                text: '嘉定',
                value: 12596,
                key: '̥',
            },
            {
                text: '浦东新区',
                value: 12597,
                key: '̦',
            },
            {
                text: '金山',
                value: 12598,
                key: '̧',
            },
            {
                text: '松江',
                value: 12599,
                key: '̨',
            },
            {
                text: '奉贤',
                value: 12854,
                key: '̩',
            },
            {
                text: '青浦',
                value: 12857,
                key: '̪',
            },
            {
                text: '崇明',
                value: 13104,
                key: '̫',
            },
        ],
    },
    {
        text: '江苏',
        value: 13106,
        key: '̬',
        children: [

            {
                text: '南京',
                value: 49,
                key: '̭',
            },
            {
                text: '无锡',
                value: 50,
                key: '̻',
            },
            {
                text: '徐州',
                value: 51,
                key: '̈́',
            },
            {
                text: '常州',
                value: 52,
                key: '͐',
            },
            {
                text: '苏州',
                value: 53,
                key: '͘',
            },
            {
                text: '南通',
                value: 54,
                key: '͢',
            },
            {
                text: '连云港',
                value: 55,
                key: 'ͫ',
            },
            {
                text: '淮安',
                value: 56,
                key: 'ͳ',
            },
            {
                text: '盐城',
                value: 57,
                key: 'ͼ',
            },
            {
                text: '扬州',
                value: 12592,
                key: 'Ά',
            },
            {
                text: '镇江',
                value: 12593,
                key: 'Ύ',
            },
            {
                text: '泰州',
                value: 12594,
                key: 'Ε',
            },
            {
                text: '宿迁',
                value: 12595,
                key: 'Μ',
            },
        ],
    },
    {
        text: '浙江',
        value: 13107,
        key: '΢',
        children: [

            {
                text: '杭州',
                value: 49,
                key: 'Σ',
            },
            {
                text: '宁波',
                value: 50,
                key: 'α',
            },
            {
                text: '温州',
                value: 51,
                key: 'ν',
            },
            {
                text: '嘉兴',
                value: 52,
                key: 'ω',
            },
            {
                text: '湖州',
                value: 53,
                key: 'ϑ',
            },
            {
                text: '绍兴',
                value: 54,
                key: 'ϗ',
            },
            {
                text: '金华',
                value: 55,
                key: 'Ϟ',
            },
            {
                text: '衢州',
                value: 56,
                key: 'Ϩ',
            },
            {
                text: '舟山',
                value: 57,
                key: 'ϯ',
            },
            {
                text: '台州',
                value: 12592,
                key: 'ϴ',
            },
            {
                text: '丽水',
                value: 12593,
                key: 'Ͼ',
            },
        ],
    },
    {
        text: '安徽',
        value: 13108,
        key: 'Ј',
        children: [

            {
                text: '合肥',
                value: 49,
                key: 'Љ',
            },
            {
                text: '芜湖',
                value: 50,
                key: 'Г',
            },
            {
                text: '蚌埠',
                value: 51,
                key: 'М',
            },
            {
                text: '淮南',
                value: 52,
                key: 'Ф',
            },
            {
                text: '马鞍山',
                value: 53,
                key: 'Ы',
            },
            {
                text: '淮北',
                value: 54,
                key: 'в',
            },
            {
                text: '铜陵',
                value: 55,
                key: 'з',
            },
            {
                text: '安庆',
                value: 56,
                key: 'м',
            },
            {
                text: '黄山',
                value: 12592,
                key: 'ш',
            },
            {
                text: '滁州',
                value: 12593,
                key: 'ѐ',
            },
            {
                text: '阜阳',
                value: 12594,
                key: 'љ',
            },
            {
                text: '宿州',
                value: 12595,
                key: 'Ѣ',
            },
            {
                text: '六安',
                value: 12597,
                key: 'Ѩ',
            },
            {
                text: '亳州',
                value: 12598,
                key: 'Ѱ',
            },
            {
                text: '池州',
                value: 12599,
                key: 'ѵ',
            },
            {
                text: '宣城',
                value: 12600,
                key: 'Ѻ',
            },
        ],
    },
    {
        text: '福建',
        value: 13109,
        key: '҂',
        children: [

            {
                text: '福州',
                value: 49,
                key: '҃',
            },
            {
                text: '厦门',
                value: 50,
                key: 'ґ',
            },
            {
                text: '莆田',
                value: 51,
                key: 'Ҙ',
            },
            {
                text: '三明',
                value: 52,
                key: 'Ҟ',
            },
            {
                text: '泉州',
                value: 53,
                key: 'ҫ',
            },
            {
                text: '漳州',
                value: 54,
                key: 'Ҹ',
            },
            {
                text: '南平',
                value: 55,
                key: 'ӄ',
            },
            {
                text: '龙岩',
                value: 56,
                key: 'ӏ',
            },
            {
                text: '宁德',
                value: 57,
                key: 'ӗ',
            },
        ],
    },
    {
        text: '江西',
        value: 13110,
        key: 'ӡ',
        children: [

            {
                text: '南昌',
                value: 49,
                key: 'Ӣ',
            },
            {
                text: '景德镇',
                value: 50,
                key: 'Ӭ',
            },
            {
                text: '萍乡',
                value: 51,
                key: 'ӱ',
            },
            {
                text: '九江',
                value: 52,
                key: 'ӷ',
            },
            {
                text: '新余',
                value: 53,
                key: 'Ԅ',
            },
            {
                text: '鹰潭',
                value: 54,
                key: 'ԇ',
            },
            {
                text: '赣州',
                value: 55,
                key: 'ԋ',
            },
            {
                text: '吉安',
                value: 56,
                key: 'Ԟ',
            },
            {
                text: '宜春',
                value: 57,
                key: 'Ԭ',
            },
            {
                text: '抚州',
                value: 12592,
                key: 'Է',
            },
            {
                text: '上饶',
                value: 12593,
                key: 'Ճ',
            },
        ],
    },
    {
        text: '山东',
        value: 13111,
        key: 'Ր',
        children: [

            {
                text: '济南',
                value: 49,
                key: 'Ց',
            },
            {
                text: '青岛',
                value: 50,
                key: '՜',
            },
            {
                text: '淄博',
                value: 51,
                key: 'թ',
            },
            {
                text: '枣庄',
                value: 52,
                key: 'ղ',
            },
            {
                text: '东营',
                value: 53,
                key: 'չ',
            },
            {
                text: '烟台',
                value: 54,
                key: 'տ',
            },
            {
                text: '潍坊',
                value: 55,
                key: '֌',
            },
            {
                text: '济宁',
                value: 56,
                key: '֙',
            },
            {
                text: '泰安',
                value: 57,
                key: '֦',
            },
            {
                text: '威海',
                value: 12592,
                key: '֭',
            },
            {
                text: '日照',
                value: 12593,
                key: 'ֲ',
            },
            {
                text: '莱芜',
                value: 12594,
                key: 'ַ',
            },
            {
                text: '临沂',
                value: 12595,
                key: 'ֺ',
            },
            {
                text: '德州',
                value: 12596,
                key: 'ׇ',
            },
            {
                text: '聊城',
                value: 12597,
                key: 'ד',
            },
            {
                text: '滨州',
                value: 12598,
                key: 'ל',
            },
            {
                text: '菏泽',
                value: 12599,
                key: 'פ',
            },
        ],
    },
    {
        text: '河南',
        value: 13361,
        key: '׮',
        children: [

            {
                text: '郑州',
                value: 49,
                key: 'ׯ',
            },
            {
                text: '开封',
                value: 50,
                key: '׼',
            },
            {
                text: '洛阳',
                value: 51,
                key: '؇',
            },
            {
                text: '平顶山',
                value: 52,
                key: 'ؗ',
            },
            {
                text: '安阳',
                value: 53,
                key: 'آ',
            },
            {
                text: '鹤壁',
                value: 54,
                key: 'ج',
            },
            {
                text: '新乡',
                value: 55,
                key: 'ز',
            },
            {
                text: '焦作',
                value: 56,
                key: 'ؿ',
            },
            {
                text: '濮阳',
                value: 57,
                key: 'ي',
            },
            {
                text: '许昌',
                value: 12592,
                key: 'ّ',
            },
            {
                text: '漯河',
                value: 12593,
                key: '٘',
            },
            {
                text: '三门峡',
                value: 12594,
                key: 'ٞ',
            },
            {
                text: '南阳',
                value: 12595,
                key: '٥',
            },
            {
                text: '商丘',
                value: 12596,
                key: 'ٳ',
            },
            {
                text: '信阳',
                value: 12597,
                key: 'ٽ',
            },
            {
                text: '周口',
                value: 12598,
                key: 'ڈ',
            },
            {
                text: '驻马店',
                value: 12599,
                key: 'ړ',
            },
            {
                text: '济源',
                value: 12600,
                key: 'ڞ',
            },
        ],
    },
    {
        text: '湖北',
        value: 13362,
        key: 'ڟ',
        children: [

            {
                text: '武汉',
                value: 49,
                key: 'ڠ',
            },
            {
                text: '黄石',
                value: 50,
                key: 'ڮ',
            },
            {
                text: '十堰',
                value: 51,
                key: 'ڵ',
            },
            {
                text: '宜昌',
                value: 53,
                key: 'ھ',
            },
            {
                text: '襄阳',
                value: 54,
                key: 'ی',
            },
            {
                text: '鄂州',
                value: 55,
                key: 'ۖ',
            },
            {
                text: '荆门',
                value: 56,
                key: 'ۚ',
            },
            {
                text: '孝感',
                value: 57,
                key: '۠',
            },
            {
                text: '荆州',
                value: 12592,
                key: 'ۨ',
            },
            {
                text: '黄冈',
                value: 12593,
                key: '۱',
            },
            {
                text: '咸宁',
                value: 12594,
                key: 'ۼ',
            },
            {
                text: '随州',
                value: 12595,
                key: '܃',
            },
            {
                text: '恩施',
                value: 12856,
                key: '܇',
            },
            {
                text: '仙桃',
                value: 14644,
                key: 'ܐ',
            },
            {
                text: '潜江',
                value: 14645,
                key: 'ܑ',
            },
            {
                text: '天门',
                value: 14646,
                key: 'ܒ',
            },
            {
                text: '神农架',
                value: 4272689,
                key: 'ܓ',
            },
        ],
    },
    {
        text: '湖南',
        value: 13363,
        key: 'ܔ',
        children: [

            {
                text: '长沙',
                value: 49,
                key: 'ܕ',
            },
            {
                text: '株洲',
                value: 50,
                key: 'ܟ',
            },
            {
                text: '湘潭',
                value: 51,
                key: 'ܩ',
            },
            {
                text: '衡阳',
                value: 52,
                key: 'ܯ',
            },
            {
                text: '邵阳',
                value: 53,
                key: 'ܼ',
            },
            {
                text: '岳阳',
                value: 54,
                key: '݉',
            },
            {
                text: '常德',
                value: 55,
                key: 'ݓ',
            },
            {
                text: '张家界',
                value: 56,
                key: 'ݝ',
            },
            {
                text: '益阳',
                value: 57,
                key: 'ݢ',
            },
            {
                text: '郴州',
                value: 12592,
                key: 'ݩ',
            },
            {
                text: '永州',
                value: 12593,
                key: 'ݵ',
            },
            {
                text: '怀化',
                value: 12594,
                key: 'ށ',
            },
            {
                text: '娄底',
                value: 12595,
                key: 'ގ',
            },
            {
                text: '湘西',
                value: 13105,
                key: 'ޔ',
            },
        ],
    },
    {
        text: '广东',
        value: 13364,
        key: 'ޝ',
        children: [

            {
                text: '广州',
                value: 49,
                key: 'ޞ',
            },
            {
                text: '韶关',
                value: 50,
                key: 'ޫ',
            },
            {
                text: '深圳',
                value: 51,
                key: '޶',
            },
            {
                text: '珠海',
                value: 52,
                key: '޽',
            },
            {
                text: '汕头',
                value: 53,
                key: '߁',
            },
            {
                text: '佛山',
                value: 54,
                key: '߉',
            },
            {
                text: '江门',
                value: 55,
                key: 'ߏ',
            },
            {
                text: '湛江',
                value: 56,
                key: 'ߗ',
            },
            {
                text: '茂名',
                value: 57,
                key: 'ߡ',
            },
            {
                text: '肇庆',
                value: 12594,
                key: 'ߨ',
            },
            {
                text: '惠州',
                value: 12595,
                key: '߱',
            },
            {
                text: '梅州',
                value: 12596,
                key: '߷',
            },
            {
                text: '汕尾',
                value: 12597,
                key: 'ࠀ',
            },
            {
                text: '河源',
                value: 12598,
                key: 'ࠅ',
            },
            {
                text: '阳江',
                value: 12599,
                key: 'ࠌ',
            },
            {
                text: '清远',
                value: 12600,
                key: 'ࠑ',
            },
            {
                text: '东莞',
                value: 12601,
                key: 'ࠚ',
            },
            {
                text: '中山',
                value: 12848,
                key: 'ࠛ',
            },
            {
                text: '潮州',
                value: 13617,
                key: 'ࠜ',
            },
            {
                text: '揭阳',
                value: 13618,
                key: 'ࠠ',
            },
            {
                text: '云浮',
                value: 13619,
                key: 'ࠦ',
            },
        ],
    },
    {
        text: '广西',
        value: 13365,
        key: 'ࠬ',
        children: [

            {
                text: '南宁',
                value: 49,
                key: '࠭',
            },
            {
                text: '柳州',
                value: 50,
                key: '࠺',
            },
            {
                text: '桂林',
                value: 51,
                key: 'ࡅ',
            },
            {
                text: '梧州',
                value: 52,
                key: 'ࡗ',
            },
            {
                text: '北海',
                value: 53,
                key: '࡟',
            },
            {
                text: '防城港',
                value: 54,
                key: 'ࡤ',
            },
            {
                text: '钦州',
                value: 55,
                key: 'ࡩ',
            },
            {
                text: '贵港',
                value: 56,
                key: '࡮',
            },
            {
                text: '玉林',
                value: 57,
                key: 'ࡴ',
            },
            {
                text: '百色',
                value: 12592,
                key: 'ࡻ',
            },
            {
                text: '贺州',
                value: 12593,
                key: '࢈',
            },
            {
                text: '河池',
                value: 12594,
                key: 'ࢍ',
            },
            {
                text: '来宾',
                value: 12595,
                key: '࢙',
            },
            {
                text: '崇左',
                value: 12596,
                key: 'ࢠ',
            },
        ],
    },
    {
        text: '海南',
        value: 13366,
        key: 'ࢨ',
        children: [

            {
                text: '海口',
                value: 49,
                key: 'ࢩ',
            },
            {
                text: '三亚',
                value: 50,
                key: 'ࢮ',
            },
            {
                text: '三沙',
                value: 51,
                key: 'ࢯ',
            },
            {
                text: '五指山',
                value: 14641,
                key: 'ࢰ',
            },
            {
                text: '琼海',
                value: 14642,
                key: 'ࢱ',
            },
            {
                text: '儋州',
                value: 14643,
                key: 'ࢲ',
            },
            {
                text: '文昌',
                value: 14645,
                key: 'ࢳ',
            },
            {
                text: '万宁',
                value: 14646,
                key: 'ࢴ',
            },
            {
                text: '东方',
                value: 14647,
                key: 'ࢵ',
            },
            {
                text: '定安',
                value: 4272693,
                key: 'ࢶ',
            },
            {
                text: '屯昌',
                value: 4272694,
                key: 'ࢷ',
            },
            {
                text: '澄迈',
                value: 4272695,
                key: 'ࢸ',
            },
            {
                text: '临高',
                value: 4272696,
                key: 'ࢹ',
            },
            {
                text: '白沙',
                value: 4272944,
                key: 'ࢺ',
            },
            {
                text: '昌江',
                value: 4272945,
                key: 'ࢻ',
            },
            {
                text: '乐东',
                value: 4272947,
                key: 'ࢼ',
            },
            {
                text: '陵水',
                value: 4272948,
                key: 'ࢽ',
            },
            {
                text: '保亭',
                value: 4272949,
                key: 'ࢾ',
            },
            {
                text: '琼中',
                value: 4272950,
                key: 'ࢿ',
            },
        ],
    },
    {
        text: '重庆',
        value: 13616,
        key: 'ࣀ',
        children: [

            {
                text: '万州',
                value: 49,
                key: 'ࣁ',
            },
            {
                text: '涪陵',
                value: 50,
                key: 'ࣂ',
            },
            {
                text: '渝中',
                value: 51,
                key: 'ࣃ',
            },
            {
                text: '大渡口',
                value: 52,
                key: 'ࣄ',
            },
            {
                text: '江北',
                value: 53,
                key: 'ࣅ',
            },
            {
                text: '沙坪坝',
                value: 54,
                key: 'ࣆ',
            },
            {
                text: '九龙坡',
                value: 55,
                key: 'ࣇ',
            },
            {
                text: '南岸',
                value: 56,
                key: 'ࣈ',
            },
            {
                text: '北碚',
                value: 57,
                key: 'ࣉ',
            },
            {
                text: '两江新区',
                value: 14389,
                key: '࣊',
            },
            {
                text: '万盛',
                value: 12592,
                key: '࣋',
            },
            {
                text: '双桥',
                value: 12593,
                key: '࣌',
            },
            {
                text: '渝北',
                value: 12594,
                key: '࣍',
            },
            {
                text: '巴南',
                value: 12595,
                key: '࣎',
            },
            {
                text: '长寿',
                value: 12849,
                key: '࣏',
            },
            {
                text: '綦江',
                value: 12850,
                key: '࣐',
            },
            {
                text: '潼南',
                value: 12851,
                key: '࣑',
            },
            {
                text: '铜梁',
                value: 12852,
                key: '࣒',
            },
            {
                text: '大足',
                value: 12853,
                key: '࣓',
            },
            {
                text: '荣昌',
                value: 12854,
                key: 'ࣔ',
            },
            {
                text: '璧山',
                value: 12855,
                key: 'ࣕ',
            },
            {
                text: '梁平',
                value: 12856,
                key: 'ࣖ',
            },
            {
                text: '城口',
                value: 12857,
                key: 'ࣗ',
            },
            {
                text: '丰都',
                value: 13104,
                key: 'ࣘ',
            },
            {
                text: '垫江',
                value: 13105,
                key: 'ࣙ',
            },
            {
                text: '武隆',
                value: 13106,
                key: 'ࣚ',
            },
            {
                text: '忠县',
                value: 13107,
                key: 'ࣛ',
            },
            {
                text: '开县',
                value: 13108,
                key: 'ࣜ',
            },
            {
                text: '云阳',
                value: 13109,
                key: 'ࣝ',
            },
            {
                text: '奉节',
                value: 13110,
                key: 'ࣞ',
            },
            {
                text: '巫山',
                value: 13111,
                key: 'ࣟ',
            },
            {
                text: '巫溪',
                value: 13112,
                key: '࣠',
            },
            {
                text: '黔江',
                value: 13113,
                key: '࣡',
            },
            {
                text: '石柱',
                value: 13360,
                key: '࣢',
            },
            {
                text: '秀山',
                value: 13361,
                key: 'ࣣ',
            },
            {
                text: '酉阳',
                value: 13362,
                key: 'ࣤ',
            },
            {
                text: '彭水',
                value: 13363,
                key: 'ࣥ',
            },
            {
                text: '江津',
                value: 14385,
                key: 'ࣦ',
            },
            {
                text: '合川',
                value: 14386,
                key: 'ࣧ',
            },
            {
                text: '永川',
                value: 14387,
                key: 'ࣨ',
            },
            {
                text: '南川',
                value: 14388,
                key: 'ࣩ',
            },
        ],
    },
    {
        text: '四川',
        value: 13617,
        key: '࣪',
        children: [

            {
                text: '成都',
                value: 49,
                key: '࣫',
            },
            {
                text: '自贡',
                value: 51,
                key: 'ࣿ',
            },
            {
                text: '攀枝花',
                value: 52,
                key: 'आ',
            },
            {
                text: '泸州',
                value: 53,
                key: 'ऌ',
            },
            {
                text: '德阳',
                value: 54,
                key: 'औ',
            },
            {
                text: '绵阳',
                value: 55,
                key: 'छ',
            },
            {
                text: '广元',
                value: 56,
                key: 'थ',
            },
            {
                text: '遂宁',
                value: 57,
                key: 'भ',
            },
            {
                text: '内江',
                value: 12592,
                key: 'ळ',
            },
            {
                text: '乐山',
                value: 12593,
                key: 'ह',
            },
            {
                text: '南充',
                value: 12595,
                key: 'ॅ',
            },
            {
                text: '眉山',
                value: 12596,
                key: 'ॏ',
            },
            {
                text: '宜宾',
                value: 12597,
                key: 'ॖ',
            },
            {
                text: '广安',
                value: 12598,
                key: 'ॡ',
            },
            {
                text: '达州',
                value: 12599,
                key: '१',
            },
            {
                text: '雅安',
                value: 12600,
                key: '९',
            },
            {
                text: '巴中',
                value: 12601,
                key: 'ॸ',
            },
            {
                text: '资阳',
                value: 12848,
                key: 'ॽ',
            },
            {
                text: '阿坝',
                value: 13106,
                key: 'ং',
            },
            {
                text: '甘孜',
                value: 13107,
                key: 'ঐ',
            },
            {
                text: '凉山',
                value: 13108,
                key: 'ণ',
            },
        ],
    },
    {
        text: '贵州',
        value: 13618,
        key: '঵',
        children: [

            {
                text: '贵阳',
                value: 49,
                key: 'শ',
            },
            {
                text: '六盘水',
                value: 50,
                key: 'ু',
            },
            {
                text: '遵义',
                value: 51,
                key: '৆',
            },
            {
                text: '安顺',
                value: 52,
                key: '৕',
            },
            {
                text: '铜仁',
                value: 12850,
                key: 'ড়',
            },
            {
                text: '黔西南',
                value: 12851,
                key: '১',
            },
            {
                text: '毕节',
                value: 12852,
                key: 'ৰ',
            },
            {
                text: '黔东南',
                value: 12854,
                key: '৹',
            },
            {
                text: '黔南',
                value: 12855,
                key: 'ਊ',
            },
        ],
    },
    {
        text: '云南',
        value: 13619,
        key: 'ਗ',
        children: [

            {
                text: '昆明',
                value: 49,
                key: 'ਘ',
            },
            {
                text: '曲靖',
                value: 51,
                key: 'ਧ',
            },
            {
                text: '玉溪',
                value: 52,
                key: '਱',
            },
            {
                text: '保山',
                value: 53,
                key: '਻',
            },
            {
                text: '昭通',
                value: 54,
                key: 'ੁ',
            },
            {
                text: '丽江',
                value: 55,
                key: '੍',
            },
            {
                text: '普洱',
                value: 56,
                key: '੓',
            },
            {
                text: '临沧',
                value: 57,
                key: 'ਫ਼',
            },
            {
                text: '楚雄',
                value: 12851,
                key: '੧',
            },
            {
                text: '红河',
                value: 12853,
                key: 'ੲ',
            },
            {
                text: '文山',
                value: 12854,
                key: '઀',
            },
            {
                text: '西双版纳',
                value: 12856,
                key: 'ઉ',
            },
            {
                text: '大理',
                value: 12857,
                key: 'ઍ',
            },
            {
                text: '德宏',
                value: 13105,
                key: 'ચ',
            },
            {
                text: '怒江',
                value: 13107,
                key: 'ઠ',
            },
            {
                text: '迪庆',
                value: 13108,
                key: 'થ',
            },
        ],
    },
    {
        text: '西藏',
        value: 13620,
        key: '઩',
        children: [

            {
                text: '拉萨',
                value: 49,
                key: 'પ',
            },
            {
                text: '昌都',
                value: 12849,
                key: 'ળ',
            },
            {
                text: '山南',
                value: 12850,
                key: 'િ',
            },
            {
                text: '日喀则',
                value: 12851,
                key: 'ૌ',
            },
            {
                text: '那曲',
                value: 12852,
                key: '૟',
            },
            {
                text: '阿里',
                value: 12853,
                key: '૪',
            },
            {
                text: '林芝',
                value: 12854,
                key: '૲',
            },
        ],
    },
    {
        text: '陕西',
        value: 13873,
        key: 'ૺ',
        children: [

            {
                text: '西安',
                value: 49,
                key: 'ૻ',
            },
            {
                text: '铜川',
                value: 50,
                key: 'ଉ',
            },
            {
                text: '宝鸡',
                value: 51,
                key: '଎',
            },
            {
                text: '咸阳',
                value: 52,
                key: 'ଛ',
            },
            {
                text: '渭南',
                value: 53,
                key: 'ପ',
            },
            {
                text: '延安',
                value: 54,
                key: 'ଶ',
            },
            {
                text: '汉中',
                value: 55,
                key: 'ୄ',
            },
            {
                text: '榆林',
                value: 56,
                key: '୐',
            },
            {
                text: '安康',
                value: 57,
                key: 'ଢ଼',
            },
            {
                text: '商洛',
                value: 12592,
                key: '୨',
            },
        ],
    },
    {
        text: '甘肃',
        value: 13874,
        key: '୰',
        children: [

            {
                text: '兰州市',
                value: 49,
                key: 'ୱ',
            },
            {
                text: '嘉峪关',
                value: 50,
                key: '୺',
            },
            {
                text: '金昌',
                value: 51,
                key: '୻',
            },
            {
                text: '白银',
                value: 52,
                key: '୾',
            },
            {
                text: '天水',
                value: 53,
                key: '஄',
            },
            {
                text: '武威',
                value: 54,
                key: '஌',
            },
            {
                text: '张掖',
                value: 55,
                key: '஑',
            },
            {
                text: '平凉',
                value: 56,
                key: '஘',
            },
            {
                text: '酒泉',
                value: 57,
                key: '஠',
            },
            {
                text: '庆阳',
                value: 12592,
                key: 'ந',
            },
            {
                text: '定西',
                value: 12593,
                key: 'ற',
            },
            {
                text: '陇南',
                value: 12594,
                key: 'ஹ',
            },
            {
                text: '临夏',
                value: 12857,
                key: '௃',
            },
            {
                text: '甘南',
                value: 13104,
                key: 'ௌ',
            },
        ],
    },
    {
        text: '青海',
        value: 13875,
        key: '௕',
        children: [

            {
                text: '西宁',
                value: 49,
                key: '௖',
            },
            {
                text: '海东',
                value: 12849,
                key: '௞',
            },
            {
                text: '海北',
                value: 12850,
                key: '௥',
            },
            {
                text: '黄南',
                value: 12851,
                key: '௪',
            },
            {
                text: '海南',
                value: 12853,
                key: '௯',
            },
            {
                text: '果洛',
                value: 12854,
                key: '௵',
            },
            {
                text: '玉树',
                value: 12855,
                key: '௼',
            },
            {
                text: '海西',
                value: 12856,
                key: 'ః',
            },
        ],
    },
    {
        text: '宁夏',
        value: 13876,
        key: 'ఉ',
        children: [

            {
                text: '银川',
                value: 49,
                key: 'ఊ',
            },
            {
                text: '石嘴山',
                value: 50,
                key: '఑',
            },
            {
                text: '吴忠',
                value: 51,
                key: 'క',
            },
            {
                text: '固原',
                value: 52,
                key: 'ఛ',
            },
            {
                text: '中卫',
                value: 53,
                key: 'డ',
            },
        ],
    },
    {
        text: '新疆',
        value: 13877,
        key: 'థ',
        children: [

            {
                text: '乌鲁木齐',
                value: 49,
                key: 'ద',
            },
            {
                text: '克拉玛依',
                value: 50,
                key: 'య',
            },
            {
                text: '吐鲁番',
                value: 12849,
                key: 'ఴ',
            },
            {
                text: '哈密',
                value: 12850,
                key: 'స',
            },
            {
                text: '昌吉',
                value: 12851,
                key: '఼',
            },
            {
                text: '博尔塔拉',
                value: 12855,
                key: 'ౄ',
            },
            {
                text: '巴音郭楞',
                value: 12856,
                key: 'ై',
            },
            {
                text: '阿克苏',
                value: 12857,
                key: '౒',
            },
            {
                text: '克孜勒苏',
                value: 13104,
                key: '౜',
            },
            {
                text: '喀什',
                value: 13105,
                key: 'ౡ',
            },
            {
                text: '和田',
                value: 13106,
                key: '౮',
            },
            {
                text: '伊犁',
                value: 13360,
                key: '౷',
            },
            {
                text: '塔城',
                value: 13362,
                key: 'ಂ',
            },
            {
                text: '阿勒泰',
                value: 13363,
                key: 'ಊ',
            },
            {
                text: '石河子',
                value: 14641,
                key: 'ಒ',
            },
            {
                text: '阿拉尔',
                value: 14642,
                key: 'ಓ',
            },
            {
                text: '图木舒克',
                value: 14643,
                key: 'ಔ',
            },
            {
                text: '五家渠',
                value: 14644,
                key: 'ಕ',
            },
            {
                text: '北屯',
                value: 14645,
                key: 'ಖ',
            },
        ],
    },
    {
        text: '台湾',
        value: 14129,
        key: 'ಗ',
        children: [

            {
                text: '台北市',
                value: 49,
                key: 'ಘ',
            },
            {
                text: '高雄市',
                value: 50,
                key: 'ಙ',
            },
            {
                text: '基隆市',
                value: 51,
                key: 'ಚ',
            },
            {
                text: '台中市',
                value: 52,
                key: 'ಛ',
            },
            {
                text: '台南市',
                value: 53,
                key: 'ಜ',
            },
            {
                text: '新竹市',
                value: 54,
                key: 'ಝ',
            },
            {
                text: '嘉义市',
                value: 55,
                key: 'ಞ',
            },
            {
                text: '台北县',
                value: 56,
                key: 'ಟ',
            },
            {
                text: '宜兰县',
                value: 57,
                key: 'ಠ',
            },
            {
                text: '桃园县',
                value: 12592,
                key: 'ಡ',
            },
            {
                text: '新竹县',
                value: 12593,
                key: 'ಢ',
            },
            {
                text: '苗栗县',
                value: 12594,
                key: 'ಣ',
            },
            {
                text: '台中县',
                value: 12595,
                key: 'ತ',
            },
            {
                text: '彰化县',
                value: 12596,
                key: 'ಥ',
            },
            {
                text: '南投县',
                value: 12597,
                key: 'ದ',
            },
            {
                text: '云林县',
                value: 12598,
                key: 'ಧ',
            },
            {
                text: '嘉义县',
                value: 12599,
                key: 'ನ',
            },
            {
                text: '台南县',
                value: 12600,
                key: '಩',
            },
            {
                text: '高雄县',
                value: 12601,
                key: 'ಪ',
            },
            {
                text: '屏东县',
                value: 12848,
                key: 'ಫ',
            },
            {
                text: '台东县',
                value: 12850,
                key: 'ಬ',
            },
            {
                text: '花莲县',
                value: 12851,
                key: 'ಭ',
            },
            {
                text: '澎湖县',
                value: 12849,
                key: 'ಮ',
            },
        ],
    },
    {
        text: '香港',
        value: 14385,
        key: 'ಯ',
        children: [

            {
                text: '中西区',
                value: 4735831,
                key: 'ರ',
            },
            {
                text: '东区',
                value: 4736321,
                key: 'ಱ',
            },
            {
                text: '九龙城区',
                value: 4934467,
                key: 'ಲ',
            },
            {
                text: '观塘区',
                value: 4934484,
                key: 'ಳ',
            },
            {
                text: '南区',
                value: 4739919,
                key: '಴',
            },
            {
                text: '深水埗区',
                value: 4936531,
                key: 'ವ',
            },
            {
                text: '黄大仙区',
                value: 4937556,
                key: 'ಶ',
            },
            {
                text: '湾仔区',
                value: 4740931,
                key: 'ಷ',
            },
            {
                text: '油尖旺区',
                value: 4938068,
                key: 'ಸ',
            },
            {
                text: '离岛区',
                value: 5130579,
                key: 'ಹ',
            },
            {
                text: '葵青区',
                value: 5131092,
                key: '಺',
            },
            {
                text: '北区',
                value: 5131855,
                key: '಻',
            },
            {
                text: '西贡区',
                value: 5133131,
                key: '಼',
            },
            {
                text: '沙田区',
                value: 5133140,
                key: 'ಽ',
            },
            {
                text: '屯门区',
                value: 5133389,
                key: 'ಾ',
            },
            {
                text: '大埔区',
                value: 5133392,
                key: 'ಿ',
            },
            {
                text: '荃湾区',
                value: 5133399,
                key: 'ೀ',
            },
            {
                text: '元朗区',
                value: 5134668,
                key: 'ು',
            },
        ],
    },
    {
        text: '澳门',
        value: 14386,
        key: 'ೂ',
        children: [

            {
                text: '花地玛堂区',
                value: 5196870,
                key: 'ೃ',
            },
            {
                text: '圣安多尼堂区',
                value: 4279892,
                key: 'ೄ',
            },
            {
                text: '大堂区',
                value: 4407636,
                key: '೅',
            },
            {
                text: '望德堂区',
                value: 4997463,
                key: 'ೆ',
            },
            {
                text: '风顺堂区',
                value: 4997466,
                key: 'ೇ',
            },
            {
                text: '氹仔',
                value: 5525569,
                key: 'ೈ',
            },
            {
                text: '路环',
                value: 4410446,
                key: '೉',
            },
        ],
    },
];
